import { loadMore } from './functions';

loadMore('main.site-main .woocommerce-pagination ul.page-numbers a.next', 'main.site-main ul.products', 'main.site-main ul.products > li', 1250);

loadMore('.nav-links .nav-previous > a', '#main-content .posts-list', '#main-content .posts-list > article', 1250);

loadMore('#reviews #comments .woocommerce-pagination ul.page-numbers a.prev', '#reviews #comments ol.commentlist', '#reviews #comments ol.commentlist > li', 10, false);
